<template>
  <div class="email-right-aside bookmark-tabcontent form theme-form datepicker-responsive">
    <div class="email-body radius-left">
      <div class="">
        <fieldset :disabled="isAdmin || form.statusCode != 'A' ? false : 'disabled'">
          <b-overlay :show="loading" rounded="sm" :style="loading ? 'height:100vh;overflow:hidden;' : ''">
            <div class="card">
              <div class="card-header d-flex customStickyCardHeader justify-content-between">
                <h6 class="mb-0" style="align-self: center">
                  {{ displayTitle() }}
                </h6>
                <div :style="fromAdmin ? '' : 'margin-right: 120px'">
                  <span class="" v-if="!form.isNew">
                    {{ $t("lbl_EMPBE_LastUpdate") }}:{{ form.lastSaveDate }}<br />
                    {{ $t("lbl_EMPBE_LastSubmit") }}:{{ form.lastSubmitDate }}<br />
                    <!-- {{ $t("lbl_EMPBE_LastThreeMonthUpdateCount") }}:
                    {{ form.lastThreeMonthSubmitCount }} -->
                  </span>
                </div>
              </div>
              <div class="card-body">
                <div class="ribbon ribbon-bookmark ribbon-right ribbon-info customRibbon" v-if="form.statusCode == 'P'">
                  {{ $t("lbl_EMPBE_Pending") }}
                </div>
                <div class="ribbon ribbon-bookmark ribbon-right ribbon-success customRibbon"
                  v-if="form.statusCode == 'A'">
                  {{ $t("lbl_EMPBE_isActivate") }}
                  <i class="fa fa-info-circle m-l-5" id="ApprovedTooltip"></i>
                  <b-tooltip target="ApprovedTooltip" triggers="hover" container="">
                    {{ $t("lbl_EMPBE_ApprovedDate") }}<br />{{ form.approvalDate }}
                  </b-tooltip>
                </div>
                <div class="ribbon ribbon-bookmark ribbon-right ribbon-danger customRibbon" v-if="form.statusCode == 'R'">
                  {{ $t("lbl_EMPBE_Rejected") }}
                  <i class="fa fa-info-circle m-l-5" id="RejectedTooltip"></i>
                  <b-tooltip target="RejectedTooltip" triggers="hover">
                    {{ $t("lbl_EMPBE_RejectedDate") }}<br />{{ form.rejectDate }} <br />
                    {{ $t("lbl_EMPBE_RejectedReason") }}<br />{{ form.rejectReason }}
                  </b-tooltip>
                </div>
                <div class="ribbon ribbon-bookmark ribbon-right ribbon-warning customRibbon f-black"
                  v-if="form.newsId > 0 && form.statusCode == undefined">
                  {{ $t("lbl_EMPBE_Draft") }}
                </div>
                <ValidationObserver ref="observer">
                  <div class="row mt-4">
                    <div class="col-sm-12" v-if="isAdmin">
                      <selection :title="$t('lbl_emp2_simpSourcingRequest_Company')" label="name"
                        v-model="form.empCompanyId" :options="EBoothAOptions">
                      </selection>
                    </div>
                    <div class="col-sm-6" v-if="false">
                      <div class="d-flex align-items-start">
                        <h6 class="mb-3 mt-2">{{ $t("lbl_EMPBE_isActivate") }}</h6>
                        <switchIput data-item="isLaunch" class="media-body m-l-15" v-model="form.isLaunch">
                        </switchIput>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <datePicker_cp :title="$t('lbl_emp2_supplierMember_Publish')"
                        input-class="datepicker-here form-control digits" v-model="form.publishDate"
                        :value="form.publishDate" :dateTimeFormat="'yyyy-MM-dd'" data-item="PublishDate"
                        @fromChird_selectDate="handleDateChange"
                        :mandatory="$t('lbl_EMPBE_PublishDate') + $t('lbl_IsRequire')">
                      </datePicker_cp>
                    </div>
                    <div class="col-12">
                      <h6>
                        {{ $t("Lbl_RelatedLabel") }} <span class="text-danger">*</span>
                        <i class="fa fa-info-circle m-l-5 m-r-5" v-bind:t_label="'EMPBE_News_Tag_Info'"
                          id="NewsTagInfo"></i>
                        <b-tooltip target="NewsTagInfo" triggers="hover" placement="right">
                          {{ $t("lbl_maximumchoices").replace("#count#", 3) }}
                        </b-tooltip>
                      </h6>
                      <multiselection label="name" v-model="form.selectedHotSearchTags"
                        :disabled="isAdmin || form.statusCode != 'A' ? false : 'disabled'"
                        :mandatory="$t('Lbl_RelatedLabel') + $t('lbl_IsRequire')" :MaxLength="3" :options="options">
                      </multiselection>
                    </div>
                    <div class="col-12 newsDetailTabs">
                      <h6 class="f-16 mb-2">{{ $t("lbl_EMPBE_NewsNotice") }}</h6>
                      <b-tabs card class="b-light" @input="onTabInput">
                        <div>
                          <b-tab :active="currentTab === 0" :title-link-attributes="{
                            t_label: 'EMPBE_NewsDetail_tab_Eng',
                          }">
                            <div slot="title">
                              {{ $t("lbl_emp2_English") }}
                            </div>
                            <div>
                              <ValidationObserver ref="observerEng">
                                <div class="col-12">
                                  <h6>
                                    {{ $t("lbl_EMPBE_Title") }}
                                    <span class="text-danger">*</span>
                                  </h6>
                                  <textbox name="titleE" v-model="form.titleE" >
                                  </textbox>
                                </div>
                                <div class="col-12">
                                  <div class="row">
                                    <div class="col-sm-6">
                                      <h6>
                                        {{ $t("lbl_EMPBE_NewsThumbnail") }}<span class="text-danger"> *</span>
                                      </h6>
                                      <div class="adReq mb-1">
                                        {{ $t("lbl_EMPBE_NewsThumbnailDesc") }}
                                      </div>
                                      <mediaUploader
                                        ref="News_Thumbnail_EN"
                                        :limit="1"
                                        :aspectRatioStr="'577:324'"
                                        :MediaArray="uploadedFiles.News_Thumbnail_EN"
                                        :isRequired="true"
                                        galleryItemStyle="height: 120px; width: 213px;"
                                        :coverPlaceholder="$t('lbl_EMPBE_CompanyInfo_Add_Cover_Image')"
                                        fileUsageType="News_Thumbnail_EN"
                                        filePathEndpoint="Image"
                                        @update="(cmd, files) => handlerUploaderUpdateData(cmd, files, 'News_Thumbnail_EN')"
                                        :isDisabled="form.statusCode == 'A'"
                                      />
                                      <b-button
                                        class="m-t-5"
                                        variant="primary"
                                        @click="btnCopyDiffLang('News_Thumbnail', 'EN')"
                                      >
                                        {{ $t('lbl_EMPBE_ApplySameImageInDiffLang') }}
                                      </b-button>
                                    </div>
                                    <div class="col-sm-6">
                                      <h6>
                                        {{ $t("lbl_EMPBE_NewsBanner") }}<span class="text-danger"> *</span>
                                      </h6>
                                      <div class="adReq mb-1">
                                        {{ $t("lbl_EMPBE_NewsBannerDesc") }}
                                      </div>
                                      <mediaUploader
                                        ref="News_Banner_EN"
                                        :limit="1"
                                        :aspectRatioStr="'1265:712'"
                                        :MediaArray="uploadedFiles.News_Banner_EN"
                                        :isRequired="true"
                                        galleryItemStyle="height: 120px; width: 213px;"
                                        :coverPlaceholder="$t('lbl_EMPBE_CompanyInfo_Add_Cover_Image')"
                                        fileUsageType="News_Banner_EN"
                                        filePathEndpoint="Image"
                                        @update="(cmd, files) => handlerUploaderUpdateData(cmd, files, 'News_Banner_EN')"
                                        :isDisabled="form.statusCode == 'A'"
                                      />
                                      <b-button class="m-t-5" variant="primary" @click="btnCopyDiffLang('News_Banner', 'EN')">
                                        {{ $t('lbl_EMPBE_ApplySameImageInDiffLang') }}
                                      </b-button>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12 mt-4">
                                  <h6>
                                    {{ $t("lbl_EMPBE_Abstract")
                                    }}<span class="text-danger"> *</span>
                                  </h6>
                                  <customtextarea :key="`CustomtextareaEN_${currentTab}`" rows="3" max="150" v-model="form.abstractE" data-item="abstractE"
                                    :placeholder="$t('lbl_EMPBE_BodyTextPlaceholder')"
                                    :customErrorMessage="{ max: $t('lbl_EMPBE_PIG_InputExceedLimit') }"
                                    :mandatory="$t('lbl_EMPBE_Abstract') + $t('lbl_IsRequire')
                                      " :isHideStar="true">
                                  </customtextarea>
                                </div>
                                <div class="col-12">
                                  <texteditor ControlId="contentE" rows="5" :title="$t('Lbl_OtherQuestionComments')"
                                    v-model="form.contentE" :mandatory="$t('Lbl_OtherQuestionComments') +
                                      $t('lbl_IsRequire')
                                      ">
                                  </texteditor>
                                </div>
                              </ValidationObserver>
                            </div>
                          </b-tab>
                          <b-tab :active="currentTab === 1" :title-link-attributes="{
                            t_label: 'EMPBE_NewsDetail_tab_Trad',
                          }">
                            <div slot="title">
                              {{ $t("lbl_emp2_Trad") }}
                            </div>
                            <div>
                              <ValidationObserver ref="observerTrad">
                                <div class="col-12">
                                  <h6>
                                    {{ $t("lbl_EMPBE_Title") }}
                                    <span class="text-danger">*</span>
                                  </h6>
                                  <textbox name="titleT" v-model="form.titleT"> </textbox>
                                </div>
                                <div class="col-12">
                                  <div class="row">
                                    <div class="col-sm-6">
                                      <h6>
                                        {{ $t("lbl_EMPBE_NewsThumbnail") }}<span class="text-danger"> *</span>
                                      </h6>
                                      <div class="adReq mb-1">
                                        {{ $t("lbl_EMPBE_NewsThumbnailDesc") }}
                                      </div>
                                      <mediaUploader
                                        ref="News_Thumbnail_TC"
                                        :limit="1"
                                        :aspectRatioStr="'577:324'"
                                        :MediaArray="uploadedFiles.News_Thumbnail_TC"
                                        :isRequired="true"
                                        galleryItemStyle="height: 120px; width: 213px;"
                                        :coverPlaceholder="$t('lbl_EMPBE_CompanyInfo_Add_Cover_Image')"
                                        fileUsageType="News_Thumbnail_TC"
                                        filePathEndpoint="Image"
                                        @update="(cmd, files) => handlerUploaderUpdateData(cmd, files, 'News_Thumbnail_TC')"
                                        :isDisabled="form.statusCode == 'A'"
                                      />
                                      <b-button
                                        class="m-t-5"
                                        variant="primary"
                                        @click="btnCopyDiffLang('News_Thumbnail', 'TC')"
                                      >
                                        {{ $t('lbl_EMPBE_ApplySameImageInDiffLang') }}
                                      </b-button>
                                    </div>
                                    <div class="col-sm-6">
                                      <h6>
                                        {{ $t("lbl_EMPBE_NewsBanner") }}<span class="text-danger"> *</span>
                                      </h6>
                                      <div class="adReq mb-1">
                                        {{ $t("lbl_EMPBE_NewsBannerDesc") }}
                                      </div>
                                      <mediaUploader
                                        ref="News_Banner_TC"
                                        :limit="1"
                                        :aspectRatioStr="'1265:712'"
                                        :MediaArray="uploadedFiles.News_Banner_TC"
                                        :isRequired="true"
                                        galleryItemStyle="height: 120px; width: 213px;"
                                        :coverPlaceholder="$t('lbl_EMPBE_CompanyInfo_Add_Cover_Image')"
                                        fileUsageType="News_Banner_TC"
                                        filePathEndpoint="Image"
                                        @update="(cmd, files) => handlerUploaderUpdateData(cmd, files, 'News_Banner_TC')"
                                        :isDisabled="form.statusCode == 'A'"
                                      />
                                      <b-button class="m-t-5" variant="primary" @click="btnCopyDiffLang('News_Banner', 'TC')">
                                        {{ $t('lbl_EMPBE_ApplySameImageInDiffLang') }}
                                      </b-button>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12 mt-4">
                                  <h6>
                                    {{ $t("lbl_EMPBE_Abstract")
                                    }}<span class="text-danger"> *</span>
                                  </h6>
                                  <customtextarea :key="`CustomtextareaTC_${currentTab}`" rows="3" max="150" v-model="form.abstractT" data-item="abstractT"
                                    :customErrorMessage="{ max: $t('lbl_EMPBE_PIG_InputExceedLimit') }"
                                    :placeholder="$t('lbl_EMPBE_BodyTextPlaceholder')" :mandatory="$t('lbl_EMPBE_Abstract') + $t('lbl_IsRequire')
                                      " :isHideStar="true">
                                  </customtextarea>
                                </div>
                                <div class="col-12">
                                  <texteditor ControlId="contentT" rows="5" :title="$t('Lbl_OtherQuestionComments')"
                                    v-model="form.contentT" :mandatory="$t('Lbl_OtherQuestionComments') +
                                      $t('lbl_IsRequire')
                                      ">
                                  </texteditor>
                                </div>
                              </ValidationObserver>
                            </div>
                          </b-tab>
                          <b-tab :active="currentTab === 2" :title-link-attributes="{
                            t_label: 'EMPBE_NewsDetail_tab_Simp',
                          }">
                            <div slot="title">
                              {{ $t("lbl_emp2_Simp") }}
                            </div>
                            <div>
                              <ValidationObserver ref="observerSimp">
                                <div class="col-12">
                                  <h6>
                                    {{ $t("lbl_EMPBE_Title") }}
                                    <span class="text-danger">*</span>
                                  </h6>
                                  <textbox name="titleS" v-model="form.titleS"> </textbox>
                                </div>
                                <div class="col-12">
                                  <div class="row">
                                    <div class="col-sm-6">
                                      <h6>
                                        {{ $t("lbl_EMPBE_NewsThumbnail") }}<span class="text-danger"> *</span>
                                      </h6>
                                      <div class="adReq mb-1">
                                        {{ $t("lbl_EMPBE_NewsThumbnailDesc") }}
                                      </div>
                                      <mediaUploader
                                        ref="News_Thumbnail_SC"
                                        :limit="1"
                                        :aspectRatioStr="'577:324'"
                                        :MediaArray="uploadedFiles.News_Thumbnail_SC"
                                        :isRequired="true"
                                        galleryItemStyle="height: 120px; width: 213px;"
                                        :coverPlaceholder="$t('lbl_EMPBE_CompanyInfo_Add_Cover_Image')"
                                        fileUsageType="News_Thumbnail_SC"
                                        filePathEndpoint="Image"
                                        @update="(cmd, files) => handlerUploaderUpdateData(cmd, files, 'News_Thumbnail_SC')"
                                        :isDisabled="form.statusCode == 'A'"
                                      />
                                      <b-button
                                        class="m-t-5"
                                        variant="primary"
                                        @click="btnCopyDiffLang('News_Thumbnail', 'SC')"
                                      >
                                        {{ $t('lbl_EMPBE_ApplySameImageInDiffLang') }}
                                      </b-button>
                                    </div>
                                    <div class="col-sm-6">
                                      <h6>
                                        {{ $t("lbl_EMPBE_NewsBanner") }}<span class="text-danger"> *</span>
                                      </h6>
                                      <div class="adReq mb-1">
                                        {{ $t("lbl_EMPBE_NewsBannerDesc") }}
                                      </div>
                                      <mediaUploader
                                        ref="News_Banner_SC"
                                        :limit="1"
                                        :aspectRatioStr="'1265:712'"
                                        :MediaArray="uploadedFiles.News_Banner_SC"
                                        :isRequired="true"
                                        galleryItemStyle="height: 120px; width: 213px;"
                                        :coverPlaceholder="$t('lbl_EMPBE_CompanyInfo_Add_Cover_Image')"
                                        fileUsageType="News_Banner_SC"
                                        filePathEndpoint="Image"
                                        @update="(cmd, files) => handlerUploaderUpdateData(cmd, files, 'News_Banner_SC')"
                                        :isDisabled="form.statusCode == 'A'"
                                      />
                                      <b-button class="m-t-5" variant="primary" @click="btnCopyDiffLang('News_Banner', 'SC')">
                                        {{ $t('lbl_EMPBE_ApplySameImageInDiffLang') }}
                                      </b-button>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12 mt-4">
                                  <h6>
                                    {{ $t("lbl_EMPBE_Abstract")
                                    }}<span class="text-danger"> *</span>
                                  </h6>
                                  <customtextarea :key="`CustomtextareaSC_${currentTab}`" rows="3" max="150" v-model="form.abstractS" data-item="abstractS"
                                    :customErrorMessage="{ max: $t('lbl_EMPBE_PIG_InputExceedLimit') }"
                                    :placeholder="$t('lbl_EMPBE_BodyTextPlaceholder')" :mandatory="$t('lbl_EMPBE_Abstract') + $t('lbl_IsRequire')
                                      " :isHideStar="true">
                                  </customtextarea>
                                </div>
                                <div class="col-12">
                                  <texteditor ControlId="contentS" rows="5" :title="$t('Lbl_OtherQuestionComments')"
                                    v-model="form.contentS" :mandatory="$t('Lbl_OtherQuestionComments') +
                                      $t('lbl_IsRequire')
                                      ">
                                  </texteditor>
                                </div>
                              </ValidationObserver>
                            </div>
                          </b-tab>
                        </div>
                      </b-tabs>
                    </div>
                  </div>
                </ValidationObserver>
              </div>
            </div>
          </b-overlay>
        </fieldset>

        <div class="customizer-formbutton" v-if="$route.params.id">
          <b-button-group>
            <button class="btn btn-light btn-lg" @click="btnDelete_Click"
              v-bind:t_label="'EMPBE_NewsInfoCenter_News_' + form.newsId + '_btnDelete'">
              <i class="fa fa-trash-o m-r-5"></i>{{ $t("lbl_EMPBE_Delete") }}
            </button>
            <b-dropdown :text="$t('lbl_EMPBE_PreviewPage')" size="lg" variant="primary" v-if="false">
              <b-dropdown-item>
                <i class="icofont icofont-monitor m-r-5"></i>{{ $t("lbl_EMPBE_PC") }}
              </b-dropdown-item>
              <b-dropdown-item>
                <i class="icofont icofont-android-tablet m-r-5"></i>{{ $t("lbl_EMPBE_Mobile") }}
              </b-dropdown-item>
            </b-dropdown>
            <!-- <button class="btn btn-outline-primary btn-lg" @click="btnCancel_Click"
                                        v-bind:t_label="'EMPBE_NewsInfoCenter_News_' + form.NewsId + '_btnCancel'">
                                        <i class="icofont icofont-undo m-r-5"></i>{{ $t("lbl_cancel") }}
                                    </button> -->
            <button class="btn btn-primary btn-lg" @click="btnSave_Click"
              v-if="(isAdmin || form.statusCode != 'A') && form.lastSubmitDate == undefined"
              v-bind:t_label="'EMPBE_NewsInfoCenter_News_' + form.newsId + '_btnSave'">
              <i class="fa fa-save m-r-5"></i>{{ $t("lbl_EMPBE_SaveDraft") }}
            </button>
            <button class="btn btn-success btn-lg" @click="btnSubmit_Click" v-if="isAdmin || form.statusCode != 'A'"
              v-bind:t_label="'EMPBE_NewsInfoCenter_News_' + form.newsId + '_btnSubmit'">
              <i class="fa fa-send m-r-5"></i>{{ $t("lbl_EMPBE_SaveAndSubmit") }}
            </button>
            <b-button variant="outline-success btn-lg" v-if="isAdmin && form.statusCode == 'P'" @click="todoApproval"
              v-bind:t_label="'EMPBE_NewsInfoCenter_News_' + form.newsId + '_btnApprove'">
              {{ $t("lbl_EMPBE_Approve") }}</b-button>
            <b-button variant="outline-secondary btn-lg" v-if="isAdmin && form.statusCode == 'P'"
              v-bind:t_label="'EMPBE_NewsInfoCenter_News_' + form.newsId + '_btnReject'"
              v-b-toggle="'disablepopup_rejectNews_' + form.newsId">{{ $t("lbl_EMPBE_Reject") }}
            </b-button>
          </b-button-group>
        </div>
        <b-sidebar ref="rejectSidebar" :id="'disablepopup_rejectNews_' + form.newsId" :title="$t('lbl_EMPBE_Reject')"
          bg-variant="white" right backdrop :shadow="true" v-if="isAdmin && form.statusCode == 'P'">
          <DisableItemVue ref="DisableItemVue_reject" @todo="todoReject">
          </DisableItemVue>
        </b-sidebar>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import { newsService, productService, LogService } from "@/_services";
import { getInitImageDataObj } from '@/_helpers/media-uploader-utils.js';
import DisableItemVue from "../management/RightPopUp/DisableItem.vue";
import mediaUploader from '../../components/form/upload/imgUploader/mediaUploader.vue';

const defaultUploadResult = {
  isSuccessful: true,
  message: "",
  failedItems: [],
};

export default {
  components: {
    DisableItemVue,
    mediaUploader
  },
  props: ["supplierId", "newsId", "fromAdmin"],
  data() {
    return {
      dirty: false,
      loading: false,
      currentTab: 0,
      newsBannerArrE: [],
      newsBannerArrS: [],
      newsBannerArrT: [],
      newsThumbnailArrE: [],
      newsThumbnailArrS: [],
      newsThumbnailArrT: [],

      // For File Upload
      uploadedFiles: {
        News_Banner_EN: [],
        News_Banner_SC: [],
        News_Banner_TC: [],
        News_Thumbnail_EN: [],
        News_Thumbnail_SC: [],
        News_Thumbnail_TC: [],
      },
      dbUpdateCommands: {
        News_Banner_EN: [],
        News_Banner_SC: [],
        News_Banner_TC: [],
        News_Thumbnail_EN: [],
        News_Thumbnail_SC: [],
        News_Thumbnail_TC: [],
      },
      pendingUploadFiles: {
        News_Banner_EN: [],
        News_Banner_SC: [],
        News_Banner_TC: [],
        News_Thumbnail_EN: [],
        News_Thumbnail_SC: [],
        News_Thumbnail_TC: [],
      },
      uploadResult: { ...defaultUploadResult },

      form: {
        empCompanyId: this.companyid > 0 ? this.companyid : null,
        isDelete: false,
        titleS: "",
        titleT: "",
        titleE: "",
        contentS: "",
        contentT: "",
        contentE: "",
        updatedBy: "",
        publishDate: "",
        tagIds: "",
        mediaFileArr: "",
        updatedBy: "",
        isLaunch: true,
        abstractS: "",
        abstractT: "",
        abstractE: "",
      },
      options: [],
      EBoothAOptions: [],
    };
  },
    computed: {
    ...mapGetters({
      getPermissionJsonByUser: "responsePermission/getPermissionJsonByUser",
    }),
    ...mapState("submitFormMessage", { isShowSubmitAlertMessage : "isShowModal" }),

    user() {
      return this.$store.state.authentication.user;
    },
    companyid() {
      return this.supplierId === null ||
        this.supplierId === undefined ||
        this.supplierId === ""
        ? this.user.empCompanyId
        : this.supplierId;
    },
    langid() {
      return localStorage.getItem("currentLangId");
    },
    isAdmin() {
      return this.user.userType == "ADMIN";
    },
    istest() {
      // console.log("this.$route.params.istest:" + this.$route.query["istest"]);
      if (this.$route.query["istest"] == "true") {
        return true;
      } else {
        return false;
      }
    },
    mediaListRef() {
      return [
        "News_Banner_EN",
        "News_Banner_SC",
        "News_Banner_TC",
        "News_Thumbnail_EN",
        "News_Thumbnail_SC",
        "News_Thumbnail_TC",
      ];
    }
  },
  watch: {
    "$route.params.id": function () {
      this.refresh();
    },
    form: {
      handler() {
        this.dirty = true;
      },
      deep: true,
    },

    isShowSubmitAlertMessage: {
      handler(newValue, oldValue) {
        if (newValue === false && oldValue === true) {
          this.AfterHideMessageModal();
        }
      }
    },
  },
  mounted() {
    this.refresh();
  },
  // created() {
  //   this.refresh();
  //   this.$watch(
  //     () => this.$route.params,
  //     (toParams, previousParams) => {
  //       this.refresh();
  //     }
  //   );
  // },
  methods: {
    AfterHideMessageModal() {
      this.uploadResult = { ...defaultUploadResult };
    },

    resetFilePendingUpdate() {
      for (const prop in this.dbUpdateCommands) {
        this.$set(this.dbUpdateCommands, prop, []);
      }

      for (const prop in this.pendingUploadFiles) {
        this.$set(this.pendingUploadFiles, prop, []);
      }

      for (const prop in this.uploadedFiles) {
        this.$set(this.uploadedFiles, prop, []);
      }
    },
    // [BLK] Only update the stored data arrays for later manipulation
    handlerUploaderUpdateData(commands, pendingFiles, uploaderType) {
      this.dbUpdateCommands[uploaderType] = [...commands];
      this.pendingUploadFiles[uploaderType] = [...pendingFiles];
    },

    showResultMessagePopup(isSuccess, message, isSubmit) {
      const isSuccessful = isSuccess && this.uploadResult.isSuccessful;
      const uploadFailedItems = this.uploadResult.failedItems;

      this.$submitFormMessage.ShowResultPopup({ isSuccess: isSuccessful, message, isSubmit, uploadFailedItems });
    },

    LogPageFormError(dataObj, action) {
      LogService.LogFormErrorWithObj(
        {
          EmpCompanyId: this.companyid,
          EmpProductId: 0,
          PageName: this.$route.path.split("/")[1],
          Action: action,
        },
        {
          ...dataObj,
          newsId: this.newsId,
        }
      );
    },

    // btnCancel_Click() {
    //   this.$swal({
    //     text: this.$t("lbl_EMPBE_ConfirmToCancel"),
    //     showCancelButton: true,
    //     confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
    //     cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
    //   }).then((res) => {
    //     if (res.isConfirmed) {
    //       this.refresh();
    //     }
    //   });
    // },

    btnSave_Click() {
      // console.log("btnSave_Click");
      this.$swal({
        text: this.$t("lbl_EMPBE_ConfirmToSave"),
        showCancelButton: true,
        confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
        cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
      }).then(async (res) => {
        if (res.isConfirmed) {
          this.todoSave();
        }
      });
    },
    btnSubmit_Click() {
      this.$swal({
        text: this.$t("lbl_EMPBE_ConfirmToSubmit"),
        showCancelButton: true,
        confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
        cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
      }).then(async (res) => {
        if (res.isConfirmed) {
          //Change validate tab-content
          var valid_Eng = true;
          var valid_Trad = true;
          var valid_Simp = true;
          //Only have title will check mandatory
          if (this.form.titleE.length > 0)
            valid_Eng = await this.$refs.observerEng.validate().then((res) => {
              return res;
            });
          if (this.form.titleT.length > 0)
            valid_Trad = await this.$refs.observerTrad.validate().then((res) => {
              return res;
            });
          if (this.form.titleS.length > 0)
            valid_Simp = await this.$refs.observerSimp.validate().then((res) => {
              return res;
            });

          if (!valid_Eng) {
            this.currentTab = 0;
          } else if (!valid_Trad) {
            this.currentTab = 1;
          } else if (!valid_Simp) {
            this.currentTab = 2;
          } else {
            this.todoSubmit();
          }
        }
      });
    },
    btnDelete_Click() {
      this.$swal({
        text: this.$t("lbl_EMPBE_SureToDelete"),
        showCancelButton: true,
        confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
        cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
      }).then(async (res) => {
        if (!res.isConfirmed) {
          return;
        }
        const isDeleted = await this.Delete();
        if (!isDeleted) {
          return;
        }
        await this.refreshParent();
        const layout = this.getNewsCenterLayout();
        if (layout) {
          layout.hideSidebarNavMenu();
        } else {
          this.$router.replace({ name: "NewsInfoCenter" });
        }
      });
    },
    getNewsCenterLayout() {
      let parent = this.$parent;
      while (parent) {
        if (parent.$refs && parent.$refs.news) {
          return parent;
        }
        parent = parent.$parent;
      }
      return null;
    },
    refreshParent() {
      const layout = this.getNewsCenterLayout();
      if (layout) {
        return layout.refresh();
      }
    },
    //刷新
    refresh() {
      Object.assign(this.$data, this.$options.data());
      this.initData();
      // this.GetSysCompanySponsorType();
    },
    /*
    日期控件，获取值
  */
    handleDateChange(newDate) {
      // console.log("选中的日期: ", newDate);
      this.form.publishDate = newDate;
    },
    //多选 选择事件
    selected(node) {
      var num = this.form.TempExhibitCats.length + 1;
      var TempExhibitCat = {
        NewsId: this.form.newsId,
        SubId: node["id"],
        MainId: node["parent"],
        OrderId: num,
      };
      this.form.TempExhibitCats.push(TempExhibitCat);
      // console.log(this.form.TempExhibitCats)
    },
    //多选 删除选择事件
    delselect(node) {
      var TempExhibitCats = [];
      // console.log(node)
      this.form.TempExhibitCats.forEach((element, index) => {
        if (node["id"] != element["SubId"]) {
          var TempExhibitCat = {
            NewsId: this.form.newsId,
            SubId: element["SubId"],
            MainId: element["MainId"],
            OrderId: index + 1,
          };
          TempExhibitCats.push(TempExhibitCat);
        }
      });
      this.form.TempExhibitCats = TempExhibitCats;
      // console.log(this.form.TempExhibitCats)
    },
    initEBoothAData() {
      //Load EboothA List
      newsService.GetNewsEBoothAData({ langId: this.langid }).then((res) => {
        if (res.isSuccessful) {
          this.EBoothAOptions = [];
          res.data.forEach((element) => {
            var item = {
              id: element.value,
              label: element.text,
            };
            this.EBoothAOptions.push(item);
          });
        }
      });
    },
    initTagData() {
      //加载热搜标签
      productService.GetMstTag({ LangId: this.langid }).then((res) => {
        if (res.isSuccessful) {
          this.options = [];
          console.log(res);
          for (let index = 0; index < res.data.length; index++) {
            var item = {
              id: res.data[index].tagId,
              label: res.data[index].text,
            };
            this.options.push(item);
          }
        }
      });
    },
    /*
      1、获取基础数据
      2、初始化数据
      */
    initData() {
      var that = this;
      this.resetFilePendingUpdate();
      var form = this.form;
      that.loading = true;
      form.empCompanyId = this.companyid;
      if (this.isAdmin) {
        form.empCompanyId = null;
      }
      form.newsId = this.$route.params.id ? this.$route.params.id : this.newsId;
      var parms = {
        LangId: this.langid,
        CompanyId: this.companyid,
      };

      //初始化数据
      if (this.isAdmin) {
        this.initEBoothAData();
      }
      this.initTagData();

      if (form.newsId > 0) {
        newsService
          .LoadNewsRecords({
            companyId: form.empCompanyId,
            isDelete: form.isDelete,
            langId: that.langid,
            newsId: form.newsId,
          })
          .then((res) => {
            if (res.isSuccessful) {
              var data = res.data;
              if (data.newsRecords.length > 0) {
                that.form = data.newsRecords[0];
                if (that.form.empCompanyId == 0) {
                  that.form.empCompanyId = null;
                }
                that.initTabIndex();
              }

              //热搜标签
              var Tags = data.newsTags;
              if (Tags.length > 0) {
                var tagsId = [];

                Tags.forEach((element) => {
                  tagsId.push(element.tagId);
                });
                that.form.selectedHotSearchTags = tagsId;
              }

              //Images
              data.newsMediaFiles.forEach((media) => {
                const langId = media.langId;
                const locale = langId == 936 ? "SC" : langId == 950 ? "TC" : langId == 1252 ? "EN" : "SC";
                const usageType = media.usageType.toLowerCase() === "news_banner" ? `News_Banner_${locale}` : media.usageType.toLowerCase() === "news_thumbnail" ? `News_Thumbnail_${locale}` : `${media.usageType}_${locale}`;
                const id = media.rid;
                const cdnLink = media.fileName;
                this.uploadedFiles[usageType].push(getInitImageDataObj({ ...media, usageType }, { id, cdnLink, orderId: 1, usageType }));
              });
            }
          })
          .finally(() => {
            that.loading = false;
            that.dirty = false;
          });
      } else {
        that.loading = false;
        that.dirty = false;
      }
    },
    async Delete() {
      const that = this;
      try {
        const res = await newsService.DeleteNewsRecords({
          NewsId: this.form.newsId,
          UpdatedBy: this.user.empCompanyId,
        });

        if (!res.isSuccessful) {
          this.LogPageFormError({ res: res }, "Delete_NewsRecords");
        }

        this.$submitFormMessage.ShowMesaagePopup({ title: res.isSuccessful ? that.$t("lbl_EMPBE_DeleteSuccess") : that.$t("lbl_EMPBE_DeleteFailed") });

        return res.isSuccessful;
      } catch (error) {
        this.LogPageFormError(
          {
            Error: {
              ErrorName: error.name,
              ErrorMessage: error.message,
              ErrorStack: error.stack
            }
          },
          "Delete_NewsRecords"
        );
        this.$submitFormMessage.ShowMesaagePopup({ title: that.$t("lbl_EMPBE_DeleteFailed") });
        return false;
      }
    },
    /**
     * 组装提交 数据
     */
    async GetParam(isSubmit) {
      var form = this.form;

      var param = {
        newsId: this.$route.params.id,
        empCompanyId: form.empCompanyId,
        isDelete: form.isDelete,
        titleS: form.titleS,
        titleT: form.titleT,
        titleE: form.titleE,
        contentS: form.contentS,
        contentT: form.contentT,
        contentE: form.contentE,
        updatedBy: form.updatedBy,
        publishDate: form.publishDate,
        tagIds: form.tagIds,
        mediaFileArr: form.mediaFileArr,
        updatedBy: this.user.empCompanyId,
        islaunch: true,
        abstractS: form.abstractS,
        abstractT: form.abstractT,
        abstractE: form.abstractE,
      };

      //热搜标签
      var tagIdsString = "";
      if (form.selectedHotSearchTags) {
        form.selectedHotSearchTags.forEach((element, index) => {
          if (index > 0) {
            tagIdsString += ",";
          }
          var IdsString = element + "|" + index;
          tagIdsString += IdsString;
        });
      }
      param.tagIds = tagIdsString;

      const fileStr = {};
      this.mediaListRef.forEach((ref) => {
        const files = this.uploadedFiles[ref];
        if (files && files.length > 0) {
          fileStr[ref] = files[0].cdnLink;
        }
      });

      const pendingFiles = [];
      this.mediaListRef.forEach((ref) => {
        const files = this.pendingUploadFiles[ref];
        if (files && files.length > 0) {
          pendingFiles.push(...files);
        }
      });

      const res = await this.$submitFormMessage.FileUploadHandleWithPopup({
        isSubmit,
        pendingFiles,
        commands: [],
        getFailedText: {
          News_Banner_EN: this.$t("lbl_emp2_English") + " - " + this.$t("lbl_EMPBE_NewsBanner"),
          News_Banner_SC: this.$t("lbl_emp2_Simp") + " - " + this.$t("lbl_EMPBE_NewsBanner"),
          News_Banner_TC: this.$t("lbl_emp2_Trad") + " - " + this.$t("lbl_EMPBE_NewsBanner"),
          News_Thumbnail_EN: this.$t("lbl_emp2_English") + " - " + this.$t("lbl_EMPBE_NewsThumbnail"),
          News_Thumbnail_SC: this.$t("lbl_emp2_Simp") + " - " + this.$t("lbl_EMPBE_NewsThumbnail"),
          News_Thumbnail_TC: this.$t("lbl_emp2_Trad") + " - " + this.$t("lbl_EMPBE_NewsThumbnail"),
        },
        uploadFinishCallback: this.uploadFinish
      });

      res.successfulList.forEach((file) => {
        fileStr[file.usageType] = file.uploadedOssUrl;
      });

      param.mediaFileArr = Object.entries(fileStr).reduce((acc, [key, value]) => {
        const newsBanner = "News_Banner";
        const newsThumbnail = "News_Thumbnail";
        const usageType = key.toLowerCase().startsWith(newsBanner.toLowerCase()) ? newsBanner : key.toLowerCase().startsWith(newsThumbnail.toLowerCase()) ? newsThumbnail : "";
        const langIdStr = key.toLowerCase().endsWith("en") ? '1252' : key.toLowerCase().endsWith("tc") ? '950' : '936';
        const fileName = "";
        const str = "0|" + value + "|" + langIdStr + "|" + usageType + "|" + fileName;
        return `${acc}${acc.length > 0 ? "," : ""}${str}`;
      }, "");

      return param;
    },
    async todoSave() {
      const that = this;
      that.loading = true;

      try {
        var Params = await this.GetParam();

        const query = {
          FormId: this.newsId,
          Action: 'Before_Save',
          FormType: 'NewsDetail',
          ErrorLog: ""
        };
        LogService.LogFormDataWithObj(query, Params);

        await newsService
          .SaveNewsRecords(Params)
          .then(async (res) => {
            this.showResultMessagePopup(res.isSuccessful, res.isSuccessful ? that.$t("lbl_EMPBE_SaveSuccess") : "", false);

            if (res.isSuccessful) {
              if (that.form.newsId != res.data) {
                that.$router.push({
                  name: that.$router.currentRoute.name,
                  params: { id: res.data },
                });
                const layout = that.getNewsCenterLayout();
                if (layout) {
                  layout.openSidebarAfterSave();
                }
              }
              that.refresh();
              await that.refreshParent();
            } else {
              this.LogPageFormError({ res: res }, "Save_SaveNewsRecords");
            }
          });
      } catch(error) {
        this.LogPageFormError(
          {
            Error: {
              ErrorName: error.name,
              ErrorMessage: error.message,
              ErrorStack: error.stack
            }
          },
          "Save_SaveNewsRecords"
        );
        console.error(error);
      }

      that.loading = false;
    },
    async todoSubmit() {
      let that = this;
      that.loading = true;

      try {
        var Params = await this.GetParam();

        const query = {
          FormId: this.newsId,
          Action: 'Before_Submit',
          FormType: 'NewsDetail',
          ErrorLog: ""
        };
        LogService.LogFormDataWithObj(query, Params);

        //Save record
        await newsService
          .SaveNewsRecords(Params)
          .then((res) => {
            if (res.isSuccessful) {
              this.$submitFormMessage.NextStepSubmitMessagePopup({ isCurrentStepFailed: false });

              newsService
                .SubmitNewsRecords({
                  NewsId: res.data,
                  UpdatedBy: that.user.empCompanyId,
                  EmpCompanyId: Params.empCompanyId,
                  LangId: this.langid,
                  istest: this.istest,
                })
                .then(async (submitRes) => {
                  this.showResultMessagePopup(submitRes.isSuccessful, submitRes.isSuccessful ? that.$t("lbl_EMPBE_SubmitSuccess") : "", true);

                  if (submitRes.isSuccessful) {
                    if (that.form.newsId != res.data) {
                      that.$router.push({
                        name: that.$router.currentRoute.name,
                        params: { id: res.data },
                      });
                    }
                    that.refresh();
                    await that.refreshParent();
                    const layout = that.getNewsCenterLayout();
                    if (layout) {
                      layout.hideSidebarNavMenu();
                    }
                  } else {
                    this.LogPageFormError({ res }, "Submit_SubmitNewsRecords");
                  }
                });
            } else {
              this.LogPageFormError({ res }, "Submit_SaveNewsRecords");
              this.showResultMessagePopup(false, "", true);
            }
          });
      } catch(error) {
        this.LogPageFormError(
          {
            Error: {
              ErrorName: error.name,
              ErrorMessage: error.message,
              ErrorStack: error.stack
            }
          },
          "Submit_SubmitNewsRecords"
        );
        console.error(error);
      }

      that.loading = false;
    },

    displayTitle() {
      if (this.langId == "1252") {
        return this.langid == "1252" && this.form.titleE != ""
          ? this.form.titleE
          : this.langid == "950" && this.form.titleT != ""
            ? this.form.titleT
            : this.form.titleS != ""
              ? this.form.titleS
              : this.$t("lbl_EMPBE_Newnews");
      } else if (this.langId == "950") {
        return this.langid == "950" && this.form.titleT != ""
          ? this.form.titleT
          : this.langid == "936" && this.form.titleS != ""
            ? this.form.titleS
            : this.form.titleE != ""
              ? this.form.titleE
              : this.$t("lbl_EMPBE_Newnews");
      } else {
        return this.langid == "936" && this.form.titleS != ""
          ? this.form.titleS
          : this.langid == "950" && this.form.titleT != ""
            ? this.form.titleT
            : this.form.titleE != ""
              ? this.form.titleE
              : this.$t("lbl_EMPBE_Newnews");
      }
    },
    initTabIndex() {
      switch (this.displayTitle()) {
        case this.form.titleE:
          this.currentTab = 0;
          break;
        case this.form.titleT:
          this.currentTab = 1;
          break;
        case this.form.titleS:
          this.currentTab = 2;
          break;
        default:
          this.currentTab = 0;
          break;
      }
    },

    uploadFinish(failedFilesFields) {
      const isSuccess = failedFilesFields.length === 0;

      this.uploadResult.isSuccessful = isSuccess;
      this.uploadResult.failedItems = [...this.uploadResult.failedItems, ...failedFilesFields];

      this.$submitFormMessage.FinishUploadPopup({ isSuccess });
    },

    onTabInput(value) {
      this.currentTab = value;
    },
    //审批
    async todoApproval() {
      this.$swal({
        text: this.$t("lbl_EMPBE_ApproveThisNews"),
        showCancelButton: true,
        confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
        cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
      }).then(async (res) => {
        if (res.isConfirmed) {
          newsService
            .ApproveNewsRecords({
              NewsId: this.form.newsId,
              StatusCode: "A",
              RejectReason: "",
              Remark: "",
              UpdatedBy: this.user.empCompanyId,
            })
            .then((res) => {
              if (res.isSuccessful) {
                this.$swal({
                  text: this.$t("lbl_EMPBE_PassApproval"),
                  showCancelButton: false,
                });
                this.refresh();
              }
            });
        }
      });
    },
    //驳回 广告
    todoReject(val) {
      var that = this;
      this.$swal({
        text: this.$t("lbl_EMPBE_RejectThisNews"),
        showCancelButton: true,
        confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
        cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
      }).then(async (res) => {
        if (res.isConfirmed) {
          newsService
            .ApproveNewsRecords({
              NewsId: this.form.newsId,
              StatusCode: "R",
              RejectReason: val,
              Remark: "",
              EmpCompanyId : this.form.empCompanyId,
              UpdatedBy: this.user.empCompanyId,
            })
            .then((res) => {
              if (res.isSuccessful) {
                that.rejectReason = "";
                that.$refs.rejectSidebar.hide();
                that.$refs.DisableItemVue_reject.text_data = "";
                that.$swal({
                  text: this.$t("lbl_EMPBE_Rejected"),
                  showCancelButton: false,
                });
                that.refresh();
              } else {
                that.$swal({
                  text: this.$t("lbl_EMPBE_RejectFailed"),
                  showCancelButton: false,
                });
              }
            });
        }
      });
    },
    btnCopyDiffLang(usageTypePrefix, locale) {
      this.$swal({
        text: this.$t("lbl_EMPBE_ConfirmToApplySameImageInDiffLang"),
        showCancelButton: true,
        confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
        cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
      }).then((res) => {
        if (res.isConfirmed) {
          const sourceType = `${usageTypePrefix}_${locale}`;
          const targetTypes = this.mediaListRef.filter((item) => item.startsWith(usageTypePrefix) && item !== sourceType);
          targetTypes.forEach((type) => {
            const langId = type.toLowerCase().endsWith("en") ? 1252 : type.toLowerCase().endsWith("tc") ? 950 : type.toLowerCase().endsWith("sc") ? 936 : 0;
            if (this.pendingUploadFiles[sourceType].length > 0) {
              const files = this.pendingUploadFiles[sourceType].map((item) => {
                return item.file instanceof File
                  ? item.file
                  : item.file instanceof Blob
                  ? new File([item.file], item.fileName, { type: item.file.type, lastModified: Date.now() }) : item.file;
              });
              this.$refs[type]?.copyFromOtherUploader(files);
            } else if (this.uploadedFiles[sourceType].length > 0) {
              this.uploadedFiles[type] = this.uploadedFiles[sourceType].map((item) => ({ ...item, usageType: type, langId }));
              this.dbUpdateCommands[type] = [];
              this.pendingUploadFiles[type] = [];
            }
          });

          // this.$nextTick(() => {
          //   console.log("this.pendingUploadFiles: ", this.pendingUploadFiles);
          //   console.log("this.uploadedFiles: ", this.uploadedFiles);
          //   console.log("this.dbUpdateCommands: ", this.dbUpdateCommands);
          // })
        }
      });
    },
  },
};
</script>
<style>
.newsDetailTabs .card-header {
  padding: 10px 30px !important;
}
</style>
